export enum FuelTransactionsTypes {
  FUEL_TRANSACTIONS_REQUEST = 'userData/fuelTransactions/FUEL_TRANSACTIONS_REQUEST',
  FUEL_TRANSACTIONS_SUCCESS = 'userData/fuelTransactions/FUEL_TRANSACTIONS_SUCCESS',
  FUEL_TRANSACTIONS_FAILURE = 'userData/fuelTransactions/FUEL_TRANSACTIONS_FAILURE',
  SET_DISPLAY_FUEL_TRANSACTIONS = 'userData/fuelTransactions/SET_DISPLAY_FUEL_TRANSACTIONS',
  SET_TOTAL_FUEL_TRANSACTIONS = 'userData/fuelTransactions/SET_TOTAL_FUEL_TRANSACTIONS',
  SELECT_FUEL_TRANSACTION = 'userData/fuelTransactions/SELECT_FUEL_TRANSACTION',
  FUEL_TRANSACTION_REQUEST = 'userData/fuelTransactions/FUEL_TRANSACTION_REQUEST',
  FUEL_TRANSACTION_SUCCESS = 'userData/fuelTransactions/FUEL_TRANSACTION_SUCCESS',
  FUEL_TRANSACTION_FAILURE = 'userData/fuelTransactions/FUEL_TRANSACTION_FAILURE',
}
